import axios from 'axios'
import * as queryBuilder from 'gql-query-builder'
import find from 'lodash/find'
import get from 'lodash/get'

import store from '../../store/configureStore'
import { RESET } from '../../store/rootReducer'
import history from '../routing/history'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_HOST_GRAPHQL,
  timeout: 60000,
})

const getHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Application-Name': process.env.REACT_APP_APPLICATION_NAME,
  }

  const {
    currentUser: { user },
  } = store.getState()

  if (user && user.token) {
    headers.Authorization = user.token
  }

  return { headers }
}

const isJWTInvalidatedError = errors => {
  return find(errors, {
    message: 'Context creation failed: Invalidated Token!',
  })
}

const isJWTExpiredError = errors => {
  return find(errors, { message: 'Context creation failed: jwt expired' })
}

const isForbiddenError = errors => {
  return find(errors, { message: "You can't access that!" })
}

const handleErrors = errors => {
  if (isJWTExpiredError(errors) || isJWTInvalidatedError(errors || isForbiddenError(errors))) {
    store.dispatch({ type: RESET })
    history.push('/login')
  } else {
    const message = get(errors, '[0].message')
    throw new Error(message)
  }
}

export const graphqlRequest = async (operation, variables = null, fields) => {
  const builtQuery = queryBuilder.query({ operation, variables, fields })

  const getResponse = async () => {
    let response
    try {
      response = await axiosInstance.post('/graphql', builtQuery, Object.assign({}, getHeaders()))
    } catch (error) {
      handleErrors(error)
    }

    const errors = get(response, 'data.errors')
    if (errors) {
      handleErrors(errors)
    }

    return get(response, 'data.data')
  }

  const response = await getResponse()

  return response
}

export const graphAPI = async (operation, variables = null) => {
  const getResponse = async () => {
    let response
    try {
      response = await axiosInstance.post(
        '/graphql',
        Object.assign({ query: operation, variables }),
        getHeaders(),
      )
    } catch (error) {
      handleErrors(error)
    }

    const errors = get(response, 'data.errors')
    if (errors) {
      handleErrors(errors)
    }

    return get(response, 'data.data')
  }

  const response = await getResponse()

  return response
}



// WEBPACK FOOTER //
// ./src/utils/graphql/graphql.js